import _ from "lodash";
import L from "leaflet";

window.addEventListener("load", function () {
    /* Back to top
    ---------------------------------------------------------------------------------------------------- */
    let scrollToTop = function (ev) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    };
    const $btnScrollTop = document.querySelectorAll("#back-to-top");

    if ($btnScrollTop.length > 0) {
        for (let bEl of $btnScrollTop) {
            bEl.addEventListener("click", scrollToTop);
        }
    }

    /* Leaflet map
    ---------------------------------------------------------------------------------------------------- */
    let gite_map = document.getElementById("map");
    if( gite_map !== null ) {

        const coordinates = [48.7744618,2.4642336];
        const map = L.map(gite_map).setView(coordinates, 13);
        L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png", {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            minZoom: 1,
            maxZoom: 19,
        }).addTo(map);
        L.marker(coordinates)
            .addTo(map)
    }
});

